import React from 'react';
import { TableHead } from '../ui/table';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';

export const SortableTableHeader = ({ 
  field, 
  children, 
  sortField, 
  sortOrder, 
  onSort,
  className = ""
}) => (
  <TableHead 
    className={`cursor-pointer hover:bg-muted/50 select-none ${className}`}
    onClick={() => onSort(field)}
  >
    <div className="flex items-center gap-1">
      {children}
      {sortField === field ? (
        sortOrder === 'asc' ? (
          <ArrowUp className="h-4 w-4" />
        ) : (
          <ArrowDown className="h-4 w-4" />
        )
      ) : (
        <ArrowUpDown className="h-4 w-4 text-muted-foreground" />
      )}
    </div>
  </TableHead>
);

export default SortableTableHeader;
